module.exports = __webpack_public_path__ + "static/media/phone.c665982.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videoBg/MagazineSpyglass/phone.mp4
// module id = rA/R
// module chunks = 1